import { FormattedMessage, injectIntl } from "react-intl";
import { Route, Switch, withRouter } from "react-router-dom";

import BudgetCategoryChart from "./BudgetCategoryChart";
import BudgetCategoryList from "./BudgetCategoryList";
import BudgetChart from "./BudgetChart";
import BudgetClientList from "./BudgetClientList";
import Card from "../Card/Card";
import CreateBudgetItemSideModal from "./CreateBudgetItemSideModal";
import CreateBudgetItemsBackupSideModal from "./CreateBudgetItemsBackupSideModal";
import BudgetClientProjectReaffectSideModal from "./BudgetClientProjectReaffectSideModal"
import { Grid, Col, Row } from "react-bootstrap";
import MainContentHeader from "../Header/MainContentHeader";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import Spinner from "../../elements/Spinner/Spinner";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import _ from "lodash-es";

import BudgetTypeSelect from "../Budget/budgetTypeSelect";

import SuperpositionHeader from "../../components/Header/SuperpositionHeader";

import { fixDateToDataBase } from "../../tools/formatDate";

import { downloadCSV } from "../../tools/downloadCSV";



class BudgetContainer extends ReportingContainer {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      showChangeProjectModal: false,
      showBackupModal: false,
      cloneFrom: null,
      tiersId: "",
      categoryId: "",
      // isChiffreDAffaires: false,
      selectedId: "",
      edges: [],
      previousNextCommand: false,
      isPrevious: true,
      isNext: true,
      workInProgress: false
    };
  }

  handleGetHistory = async (type, locale) => {
    console.log("handleGetHistory", type, locale, this.props);

    let variables = {
      companyId: this.props.companyId,
      budgetType: type,
      locale: (locale.length >= 2 ? locale.substring(0, 2) : "en")
    };

    this.sendHistoryBudgetStartedNotification();

    if (type === "CLIENT") {
      const res = await this.props.getBudgetHistory({ variables: variables });
      console.log("63 - res=", res);

      let url = "";
      let label = "";
      if (
        res &&
        res.data &&
        res.data.getBudgetHistory &&
        res.data.getBudgetHistory.url
      ) {

        const awsRoot = "https://s3-eu-west-1.amazonaws.com";
        const bucket = "netwips";

        url = awsRoot + "/" + bucket + "/" + res.data.getBudgetHistory.url;

        label = "";
        downloadCSV(url, label);
      }
      else
        this.sendHistoryBudgetFailedNotification();
    }
    else {
      const res = await this.props.getBudgetHistory({ variables: variables });
      console.log("85 - res=", res);

      let url = "";
      let label = "";
      if (
        res &&
        res.data &&
        res.data.getBudgetHistory &&
        res.data.getBudgetHistory.url
      ) {

        const awsRoot = "https://s3-eu-west-1.amazonaws.com";
        const bucket = "netwips";

        url = awsRoot + "/" + bucket + "/" + res.data.getBudgetHistory.url;

        label = "";
        downloadCSV(url, label);
      }
      else
        this.sendHistoryBudgetFailedNotification();
    }
  }

  handleGetHistory2 = async (type, locale) => {
    console.log("handleGetHistory2", type, locale, this.props);

    let variables = {
      companyId: this.props.companyId,
      budgetType: type,
      locale: (locale.length >= 2 ? locale.substring(0, 2) : "en")
    };

    this.sendHistoryBudgetStartedNotification();

    if (type === "CLIENT") {
      const res = await this.props.getBudgetHistory2({ variables: variables });
      console.log("63 - res=", res);

      let url = "";
      let label = "";
      if (
        res &&
        res.data &&
        res.data.getBudgetHistory2 &&
        res.data.getBudgetHistory2.url
      ) {

        const awsRoot = "https://s3-eu-west-1.amazonaws.com";
        const bucket = "netwips";

        url = awsRoot + "/" + bucket + "/" + res.data.getBudgetHistory2.url;

        label = "";
        downloadCSV(url, label);
      }
      else
        this.sendHistoryBudgetFailedNotification();
    }
    else {
      const res = await this.props.getBudgetHistory2({ variables: variables });
      console.log("85 - res=", res);

      let url = "";
      let label = "";
      if (
        res &&
        res.data &&
        res.data.getBudgetHistory2 &&
        res.data.getBudgetHistory2.url
      ) {

        const awsRoot = "https://s3-eu-west-1.amazonaws.com";
        const bucket = "netwips";

        url = awsRoot + "/" + bucket + "/" + res.data.getBudgetHistory2.url;

        label = "";
        downloadCSV(url, label);
      }
      else
        this.sendHistoryBudgetFailedNotification();
    }
  }

  handleCreateBudgetBackup = args => {
    console.log("handleCreateBudgetBackup", args);
    this.setState({ showBackupModal: true, cloneFrom: args });
  };

  handleClientBudgetEdit = (args, edges) => {
    let foundNext = 0;
    let foundPrevious = 0;

    // console.log("183 - edges=", edges, this.state.isPrevious, this.state.isNext);

    if (edges && edges.length > 0) {
      let index = 0;
      let found = 0;

      while (index < edges.length && found === 0) {
        const edge = edges[index];

        if (edge.node.id === args.selectedId) {
          found = 1;
        } else index++;
      }

      if (found === 1) {

        // console.log("198 - edges[index]=", edges[index]);


        // -----
        let indexPrevious = index - 1;
        while (indexPrevious >= 0 && foundPrevious === 0) {
          const edgePrevious = edges[indexPrevious];

          // console.log("207 - edgePrevious=", edgePrevious);

          if (
            edgePrevious.node.budgetCurrent !== null ||
            edgePrevious.node.budgetNext !== null
          ) {
            foundPrevious = 1;
          } else indexPrevious--;
        }
        // console.log("216 - edgePrevious DONE");

        // -----
        let indexNext = index + 1;
        while (indexNext < edges.length && foundNext === 0) {
          const edgeNext = edges[indexNext];

          // console.log("223 - edgeNext=", edgeNext);

          if (
            edgeNext.node.budgetCurrent !== null ||
            edgeNext.node.budgetNext !== null
          ) {
            foundNext = 1;
          } else indexNext++;
        }
        // console.log("232 - edgeNext DONE");
      }
    }

    this.setState({
      showModal: true,
      showChangeProjectModal: false,
      cloneFrom: args,
      tiersId: args.id,
      categoryId: "",
      categoryName: args.name,
      // isChiffreDAffaires: args.isChiffreDAffaires,
      selectedId: args.selectedId,
      edges: edges,
      isPrevious: foundPrevious === 0 ? false : true,
      isNext: foundNext === 0 ? false : true
    });
  };

  handleChangeBudgetProject = (args) => {

    // console.log("111 - handleChangeBudgetProject=", args);

    this.setState({
      showModal: false,
      showChangeProjectModal: true,
      cloneFrom: args,
      tiersId: args.id,
      projectId: args.budgetProject && args.budgetProject.id || "",
      categoryId: "",
      categoryName: "",
      selectedId: args.selectedId,
      isPrevious: false,
      isNext: false,
      workInProgress: true
    });
  };

  handleCategoryBudgetEdit = (args, edges) => {
    // console.log("50 - args=", args);
    // console.log("51 - edges=", edges);

    let foundNext = 0;
    let foundPrevious = 0;

    if (edges && edges.length > 0) {
      let index = 0;
      let found = 0;

      while (index < edges.length && found === 0) {
        const edge = edges[index];

        if (edge.node.id === args.selectedId) {
          found = 1;
        } else index++;
      }

      if (found === 1) {
        // -----
        let indexPrevious = index - 1;
        while (indexPrevious >= 0 && foundPrevious === 0) {
          const edgePrevious = edges[indexPrevious];
          if (
            edgePrevious.node.budgetCurrent !== null ||
            edgePrevious.node.budgetNext !== null
          ) {
            foundPrevious = 1;
          } else indexPrevious--;
        }

        // -----
        let indexNext = index + 1;
        while (indexNext < edges.length && foundNext === 0) {
          const edgeNext = edges[indexNext];
          if (
            edgeNext.node.budgetCurrent !== null ||
            edgeNext.node.budgetNext !== null
          ) {
            foundNext = 1;
          } else indexNext++;
        }
      }
    }

    this.setState({
      showModal: true,
      showChangeProjectModal: false,
      cloneFrom: args,
      categoryId: args.id,
      categoryName: args.name,
      // isChiffreDAffaires: args.isChiffreDAffaires,
      tiersId: "",
      selectedId: args.selectedId,
      edges: edges,
      isPrevious: foundPrevious === 0 ? false : true,
      isNext: foundNext === 0 ? false : true
    });
  };

  sendSuccessCreateNotification = () => {
    const { sendNotification } = this.props;
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_quotationHasBeenCreated" />;
    sendNotification(notif);
  };

  sendFailureCreateNotification = () => {
    const { sendNotification } = this.props;

    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage id="ids_errorQuotationCouldNotBeCreated" />
    );
    sendNotification(notif);
  };

  sendHistoryBudgetStartedNotification = () => {
    const { sendNotification } = this.props;
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_historyBudgetStarted" />;
    sendNotification(notif);
  };

  sendHistoryBudgetFailedNotification = () => {
    const { sendNotification } = this.props;
    let notif = NotificationProvider.getFailureNotification();
    notif.message = <FormattedMessage id="ids_historyBudgetFailed" />;
    sendNotification(notif);
  };

  handleBackupBudget = async (name, observations, dateDebut) => {
    // console.log("165 - name=", name);
    // console.log("166 - observations=", observations);
    // console.log("167 - dateDebut=", dateDebut);
    // console.log("168 - companyId=", this.props.companyId);
    // console.log("169 - props=", this.props);
    // console.log("188 - this=", this);

    const dateDebutFixed = fixDateToDataBase(dateDebut);

    const variables = {
      companyId: this.props.companyId,
      name: name,
      observations: observations,
      dateDebut: dateDebutFixed
    };

    console.log("Call createBudgetItemsBackup....", variables);
    try {
      const res = await this.props
        .createBudgetItemsBackup({
          variables
        })
        .then(r => {
          console.log("r", r);
        });
      console.log("res", res);

      this.sendSuccessCreateNotification();
    } catch (e) {
      console.log(e);
      this.sendFailureCreateNotification();
    }
  };

  handleBudgetSetPreviousNextCommand = args => {
    this.setState({
      previousNextCommand: args
    });
  };

  handleCategoryBudgetGoPrevious = args => {
    // console.log("226 - handleCategoryBudgetGoPrevious=", this.state);
    if (this.state.edges && this.state.edges.length > 0) {
      let index = this.state.edges.length - 1;
      let found = 0;

      while (index >= 0 && found === 0) {
        const edge = this.state.edges[index];

        if (edge.node.id === args.variables.selectedId) {
          found = 1;
        }
        index--;
      }

      if (found === 1) {
        found = 0;
        while (index >= 0 && found === 0) {
          const edge = this.state.edges[index];
          if (
            edge.node.id !== "fake_id_for_according_to_budget_client_null_null" &&
            (
              edge.node.budgetCurrent !== null ||
              edge.node.budgetNext !== null
            )
          ) {
            found = 1;

            // -----
            let foundPrevious = 0;
            let indexPrevious = index - 1;
            while (indexPrevious >= 0 && foundPrevious === 0) {
              const edgePrevious = this.state.edges[indexPrevious];
              if (
                edgePrevious.node.budgetCurrent !== null ||
                edgePrevious.node.budgetNext !== null
              ) {
                foundPrevious = 1;
              } else indexPrevious--;
            }

            // -----
            let foundNext = 0;
            let indexNext = index + 1;
            while (indexNext < this.state.edges.length && foundNext === 0) {
              const edgeNext = this.state.edges[indexNext];
              if (
                edgeNext.node.budgetCurrent !== null ||
                edgeNext.node.budgetNext !== null
              ) {
                foundNext = 1;
              } else indexNext++;
            }

            const newNode = {
              ...edge.node,
              selectedId: edge.node.id
            };

            let str = edge.node.id;
            if (str.substring(0, 5) === "fake_") {
              str = str.substring(5, str.length);
              newNode.id = str.substring(0, str.indexOf("_"));
            }

            // newNode.isChiffreDAffaires = newNode.categoryFamily && newNode.categoryFamily.ids === "ids_chiffreDAffaires";
            // console.log("287 - newNode=", newNode);

            this.setState({
              showModal: true,
              showChangeProjectModal: false,
              cloneFrom: newNode,
              categoryId: newNode.id,
              categoryName: newNode.name,
              // isChiffreDAffaires: newNode.isChiffreDAffaires,
              tiersId: "",
              selectedId: edge.node.id,
              edges: this.state.edges,
              previousNextCommand: true,
              isPrevious: foundPrevious === 0 ? false : true,
              isNext: foundNext === 0 ? false : true
            });
          } else index--;
        }
      }
    }
  };

  handleCategoryBudgetGoNext = args => {
    // console.log("309 - handleCategoryBudgetGoNext=", this.state);
    if (this.state.edges && this.state.edges.length > 0) {
      let index = 0;
      let found = 0;

      while (index < this.state.edges.length && found === 0) {
        const edge = this.state.edges[index];

        if (edge.node.id === args.variables.selectedId) {
          found = 1;
        }
        index++;
      }

      if (found === 1) {
        found = 0;

        while (index < this.state.edges.length && found === 0) {
          const edge = this.state.edges[index];

          // console.log("330 - edge=", edge);
          if (
            edge.node.id !== "fake_id_for_according_to_budget_client_null_null" &&
            (
              edge.node.budgetCurrent !== null ||
              edge.node.budgetNext !== null
            )
          ) {
            found = 1;
            // console.log("FOUND...", edge);

            // -----
            let foundPrevious = 0;
            let indexPrevious = index - 1;
            while (indexPrevious >= 0 && foundPrevious === 0) {
              const edgePrevious = this.state.edges[indexPrevious];
              if (
                edgePrevious.node.budgetCurrent !== null ||
                edgePrevious.node.budgetNext !== null
              ) {
                foundPrevious = 1;
              } else indexPrevious--;
            }

            // -----
            let foundNext = 0;
            let indexNext = index + 1;
            while (indexNext < this.state.edges.length && foundNext === 0) {
              const edgeNext = this.state.edges[indexNext];
              if (
                edgeNext.node.budgetCurrent !== null ||
                edgeNext.node.budgetNext !== null
              ) {
                foundNext = 1;
              } else indexNext++;
            }

            const newNode = {
              ...edge.node,
              selectedId: edge.node.id
            };

            let str = edge.node.id;
            if (str.substring(0, 5) === "fake_") {
              str = str.substring(5, str.length);
              newNode.id = str.substring(0, str.indexOf("_"));
            }

            // newNode.isChiffreDAffaires = newNode.categoryFamily && newNode.categoryFamily.ids === "ids_chiffreDAffaires";

            // console.log("372 - newNode=", newNode);
            this.setState({
              showModal: true,
              showChangeProjectModal: false,
              cloneFrom: newNode,
              categoryId: newNode.id,
              categoryName: newNode.name,
              // isChiffreDAffaires: newNode.isChiffreDAffaires,
              tiersId: "",
              selectedId: edge.node.id,
              edges: this.state.edges,
              previousNextCommand: true,
              isPrevious: foundPrevious === 0 ? false : true,
              isNext: foundNext === 0 ? false : true
            });
          } else index++;
        }
      }
    }
  };

  handleBudgetClientGoPrevious = args => {
    // console.log("165 - handleBudgetClientGoPrevious=", this.state);
    if (this.state.edges && this.state.edges.length > 0) {
      let index = this.state.edges.length - 1;
      let found = 0;

      while (index >= 0 && found === 0) {
        const edge = this.state.edges[index];

        if (edge.node.id === args.variables.selectedId) {
          // console.log("FOUND...", edge);
          found = 1;
        }
        index--;
      }

      if (found === 1) {

        const nameSorter = edge => edge.node.name.toLowerCase();
        // const sortedEdges = _.orderBy(this.state.edges, [nameSorter], ['asc']);
        const sortedEdges = this.state.edges;

        found = 0;
        while (index >= 0 && found === 0) {
          const edge = sortedEdges[index];
          if (
            edge.node.budgetCurrent !== null ||
            edge.node.budgetNext !== null
          ) {
            found = 1;

            // -----
            let foundPrevious = 0;
            let indexPrevious = index - 1;
            while (indexPrevious >= 0 && foundPrevious === 0) {
              const edgePrevious = sortedEdges[indexPrevious];
              if (
                edgePrevious.node.budgetCurrent !== null ||
                edgePrevious.node.budgetNext !== null
              ) {
                foundPrevious = 1;
              } else indexPrevious--;
            }

            // -----
            let foundNext = 0;
            let indexNext = index + 1;
            while (indexNext < sortedEdges.length && foundNext === 0) {
              const edgeNext = sortedEdges[indexNext];
              if (
                edgeNext.node.budgetCurrent !== null ||
                edgeNext.node.budgetNext !== null
              ) {
                foundNext = 1;
              } else indexNext++;
            }

            const newNode = {
              ...edge.node,
              selectedId: edge.node.id
            };

            let str = edge.node.id;
            if (str.substring(0, 5) === "fake_") {
              str = str.substring(5, str.length);
              newNode.id = str.substring(0, str.indexOf("_"));
            }

            // console.log("92 - newNode=", newNode);
            this.setState({
              showModal: true,
              showChangeProjectModal: false,
              cloneFrom: newNode,
              tiersId: newNode.id,
              categoryId: "",
              categoryName: newNode.name,
              // isChiffreDAffaires: newNode.isChiffreDAffaires,
              selectedId: edge.node.id,
              edges: sortedEdges,
              previousNextCommand: true,
              isPrevious: foundPrevious === 0 ? false : true,
              isNext: foundNext === 0 ? false : true
            });
          } else index--;
        }
      }
    }
  };

  handleBudgetClientGoNext = args => {
    // console.log("219 - handleBudgetClientGoNext=", this.state);

    if (this.state.edges && this.state.edges.length > 0) {
      let index = 0;
      let found = 0;

      while (index < this.state.edges.length && found === 0) {
        const edge = this.state.edges[index];

        if (edge.node.id === args.variables.selectedId) {
          // console.log("FOUND...", edge);
          found = 1;
        }
        index++;
      }

      if (found === 1) {

        const nameSorter = edge => edge.node.name.toLowerCase();
        // const sortedEdges = _.orderBy(this.state.edges, [nameSorter], ['asc']);

        const sortedEdges = this.state.edges;

        found = 0;
        while (index < sortedEdges.length && found === 0) {
          const edge = sortedEdges[index];
          if (
            edge.node.budgetCurrent !== null ||
            edge.node.budgetNext !== null
          ) {
            found = 1;

            // -----
            let foundPrevious = 0;
            let indexPrevious = index - 1;
            while (indexPrevious >= 0 && foundPrevious === 0) {
              const edgePrevious = sortedEdges[indexPrevious];
              if (
                edgePrevious.node.budgetCurrent !== null ||
                edgePrevious.node.budgetNext !== null
              ) {
                foundPrevious = 1;
              } else indexPrevious--;
            }

            // -----
            let foundNext = 0;
            let indexNext = index + 1;
            while (indexNext < sortedEdges.length && foundNext === 0) {
              const edgeNext = sortedEdges[indexNext];
              if (
                edgeNext.node.budgetCurrent !== null ||
                edgeNext.node.budgetNext !== null
              ) {
                foundNext = 1;
              } else indexNext++;
            }

            const newNode = {
              ...edge.node,
              selectedId: edge.node.id
            };

            let str = edge.node.id;
            if (str.substring(0, 5) === "fake_") {
              str = str.substring(5, str.length);
              newNode.id = str.substring(0, str.indexOf("_"));
            }

            // console.log("261 - newNode=", newNode);

            this.setState({
              showModal: true,
              showChangeProjectModal: false,
              cloneFrom: newNode,
              tiersId: newNode.id,
              categoryId: "",
              categoryName: newNode.name,
              // isChiffreDAffaires: newNode.isChiffreDAffaires,
              selectedId: edge.node.id,
              edges: sortedEdges,
              previousNextCommand: true,
              isPrevious: foundPrevious === 0 ? false : true,
              isNext: foundNext === 0 ? false : true
            });
          } else index++;
        }
      }
    }
  };

  hideSideBar = () => {
    this.setState({
      showModal: false,
      showChangeProjectModal: false,
      showBackupModal: false,
      cloneFrom: null,
      workInProgress: false
      // tiersId: "",
      // categoryId: ""
    });
  };

  budgetProjectChange = async (variables) => {

    // console.log("618 - variables=", variables);
    // console.log("Call changeBudgetProject....", variables);

    try {
      const res = await this.props.changeBudgetProject({
        variables,
        refetchQueries: [
          { query: Queries.getBudgetProjectsForATiers, variables: { companyId: variables.companyId, tiersId: variables.tiersId } },
        ]
      })
        .then(r => {
          console.log("r", r);
        });
      console.log("res", res);

      this.hideSideBar();
      this.sendSuccessCreateNotification();
    } catch (e) {
      console.log(e);
      this.hideSideBar();
      this.sendFailureCreateNotification();
    }
  };

  render() {
    const {
      companyDefaultInfos,
      companyId,
      sendNotification,
      // name,
      // path,
      currency,
      intl,
      role
    } = this.props;

    console.log("intl=", intl);

    const year = new Date();
    const currentYear = year.getFullYear();
    const nextYear = year.getFullYear() + 1;

    if (!companyDefaultInfos.company) {
      return <Spinner size="lg" fullScreen />;
    }

    const currencyId =
      companyDefaultInfos &&
      companyDefaultInfos.company &&
      companyDefaultInfos.company.currency &&
      companyDefaultInfos.company.currency.id;

    // console.log("84 - BudgetContainer.props", this.props);
    // console.log("85 - BudgetContainer.state", this.state);

    const isCategoryBudgets = !!this.state.categoryId;

    const title = (this.state.categoryName) ?
      (<div>
        {intl.formatMessage({ id: "ids_budget" }) +
          " " + intl.formatMessage({ id: "ids_colon" }) + " "}
        <span style={{ fontWeight: "bold" }} >
          {this.state.categoryName}
        </span>
      </div>) : (
        <div>
          {intl.formatMessage({ id: "ids_addBudgetItem" })}
        </div>
      )

    return (
      <React.Fragment>
        {/* // should only be activated when EDITING a budget */}
        {/* {this.state.cloneFrom && ( */}

        <CreateBudgetItemSideModal
          title={title}
          categoryName={this.state.categoryName}
          //   <div>
          //   {intl.formatMessage({ id: "ids_budget" }) +
          //   " " +
          //   this.state.categoryName ||
          //   intl.formatMessage({ id: "ids_addBudgetItem" })}
          //   </div>
          // }
          sideModalVisible={this.state.showModal}
          close={this.hideSideBar}
          companyId={this.props.companyId}
          tiersId={
            this.state.categoryId
              ? this.state.cloneFrom &&
              this.state.cloneFrom.budgetTiersSupplier &&
              this.state.cloneFrom.budgetTiersSupplier.id
              : this.state.cloneFrom && this.state.cloneFrom.id
          }
          categoryId={this.state.categoryId}
          projectId={
            (this.state.cloneFrom &&
              this.state.cloneFrom.budgetProject &&
              this.state.cloneFrom.budgetProject.id) ||
            ""
          }
          tiersClientId={
            this.state.cloneFrom &&
            this.state.cloneFrom.budgetTiersClient &&
            this.state.cloneFrom.budgetTiersClient.id
          }
          isReal={this.state.cloneFrom && this.state.cloneFrom.budgetIsReal}
          currencyId={currencyId}
          intl={this.props.intl}
          cloneFrom={this.state.cloneFrom}
          goPreviousBudget={
            isCategoryBudgets
              ? this.handleCategoryBudgetGoPrevious
              : this.handleBudgetClientGoPrevious
          }
          goNextBudget={
            isCategoryBudgets
              ? this.handleCategoryBudgetGoNext
              : this.handleBudgetClientGoNext
          }
          skipPrevious={!!!this.state.isPrevious}
          skipNext={!!!this.state.isNext}
          previousNextCommand={this.state.previousNextCommand}
          setPreviousNextCommand={this.handleBudgetSetPreviousNextCommand}
          sendNotification={sendNotification}
          role={this.props.role}
        />
        <CreateBudgetItemsBackupSideModal
          title={intl.formatMessage({ id: "ids_budgetBackup" })}
          sideModalVisible={this.state.showBackupModal}
          close={this.hideSideBar}
          companyId={this.props.companyId}
          intl={this.props.intl}
          sendNotification={sendNotification}
        />

        <BudgetClientProjectReaffectSideModal
          title={intl.formatMessage({ id: "ids_changeBudgetProject" })}
          sideModalVisible={this.state.showChangeProjectModal}
          close={this.hideSideBar}
          companyId={this.props.companyId}
          tiersId={this.state.tiersId || (this.state.cloneFrom &&
            this.state.cloneFrom.client &&
            this.state.cloneFrom.client.id)}
          intl={this.props.intl}
          sendNotification={sendNotification}
          formValues={this.state.cloneFrom}
          confirm={this.budgetProjectChange}
        // workInProgress={this.state.workInProgress}
        />

        {/* )} */}
        <Switch>
          <Route
            path="/budget/clients"
            component={() => (
              <div>
                <FormattedMessage id={"ids_budget"}>
                  {backBtnText => (
                    <SuperpositionHeader
                      backBtnText={backBtnText}
                      transparent={true}
                      handleMinimizeSidebar={this.props.handleMinimizeSidebar}
                    >
                    </SuperpositionHeader>
                  )}
                </FormattedMessage>

                <Grid fluid>
                  <div className="main-content" style={{ marginTop: "32px" }}>
                    <Row>
                      <div>
                        <Col xs={12} sm={5} lg={5} mdOffset={3}>
                          <BudgetTypeSelect
                            value={"BUDGETS_CLIENT"}
                            companyId={this.props.companyId}
                            intl={this.props.intl}
                            history={this.props.history}
                            role={this.props.role}
                            path={this.props.path}
                          >
                          </BudgetTypeSelect>
                        </Col>
                      </div>
                    </Row>

                    <div className="margin-top-40">

                      {/* <MainContentHeader name={"ids_budgetClient"} /> */}
                      <Card>
                        <BudgetClientList
                          deleteClients={() => { }}
                          // onRowSelect={inSelection => setVisibleFilters(!inSelection)}
                          companyId={companyId}
                          // searchTerm={searchTerm}
                          currency={currency}
                          budgetMode={true}
                          // tabSelected={tabSelected}
                          currentYear={currentYear.toString()}
                          nextYear={nextYear.toString()}
                          handleEditBudget={this.handleClientBudgetEdit}
                          handleChangeBudgetProject={this.handleChangeBudgetProject}
                          handleBackupBudget={this.handleBackupBudget}
                          role={role}
                          showBackupModal={this.handleCreateBudgetBackup}
                          getHistory={o => this.handleGetHistory("CLIENT", intl.locale)}
                          getHistory2={o => this.handleGetHistory2("CLIENT", intl.locale)}
                        />
                      </Card>
                    </div>
                  </div>
                </Grid>
              </div>
            )}
          />
          <Route
            path="/budget/categories"
            component={() => (
              <div>
                <FormattedMessage id={"ids_budget"}>
                  {backBtnText => (
                    <SuperpositionHeader
                      backBtnText={backBtnText}
                      transparent={true}
                      handleMinimizeSidebar={this.props.handleMinimizeSidebar}
                    >
                    </SuperpositionHeader>
                  )}
                </FormattedMessage>

                <Grid fluid>
                  <div className="main-content" style={{ marginTop: "32px" }}>
                    <Row>
                      <div>
                        <Col xs={12} sm={5} lg={5} mdOffset={3}>
                          <BudgetTypeSelect
                            value={"BUDGET_CATEGORY"}
                            companyId={this.props.companyId}
                            intl={this.props.intl}
                            history={this.props.history}
                            role={this.props.role}
                            path={this.props.path}
                          >
                          </BudgetTypeSelect>
                        </Col>
                      </div>
                    </Row>

                    <div className="margin-top-40">

                      <Card>
                        <BudgetCategoryList
                          deleteClients={() => { }}
                          // onRowSelect={inSelection => setVisibleFilters(!inSelection)}
                          companyId={companyId}
                          // searchTerm={searchTerm}
                          currency={currency}
                          budgetMode={true}
                          // tabSelected={tabSelected}
                          currentYear={currentYear.toString()}
                          nextYear={nextYear.toString()}
                          handleEditBudget={this.handleCategoryBudgetEdit}
                          handleBackupBudget={this.handleBackupBudget}
                          role={role}
                          showBackupModal={this.handleCreateBudgetBackup}
                          getHistory={o => this.handleGetHistory("CATEGORY", intl.locale)}
                          getHistory2={o => this.handleGetHistory2("CATEGORY", intl.locale)}
                        />
                      </Card>
                    </div>
                  </div>
                </Grid>
              </div>
            )}
          />
          <Route
            path="/budget/clientReport"
            component={() => (
              <ReportingContainer
                {...this.props}
                type={"ETAT_BUDGET_CLIENT"}
                header={"ids_budgetClientReport"}
                query={Queries.getBudgetReportData}
                Chart={BudgetChart}
                hideBudgetTypeSelect={false}
                hideReportsTypeSelect={true}
              />
            )}
          />
          <Route
            path="/budget/categoryReport"
            component={() => (
              <ReportingContainer
                {...this.props}
                type={"ETAT_BUDGET_CATEGORY"}
                header={"ids_budgetCategoryReport"}
                // query={Queries.getBudgetReportData}
                query={Queries.getBudgetCategoryReportData}
                Chart={BudgetCategoryChart}
                hideBudgetTypeSelect={false}
                hideReportsTypeSelect={true}
              />
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

export default compose(
  graphql(Queries.getCompanyInfoForContainer, { name: "companyDefaultInfos" }),
  graphql(Queries.GetCountryByLabel, {
    options: {
      variables: {
        label: "FR"
      }
    },
    name: "defaultCountry"
  }),
  graphql(Queries.createBudgetItemsBackup, { name: "createBudgetItemsBackup" }),
  graphql(Queries.changeBudgetProject, { name: "changeBudgetProject" }),
  graphql(Queries.getBudgetHistory, { name: "getBudgetHistory" }),
  graphql(Queries.getBudgetHistory2, { name: "getBudgetHistory2" })
)(withRouter(injectIntl(BudgetContainer)));
